import ButtonSecondary from '@components/common/ButtonSecondary';
import React, { Dispatch, SetStateAction } from 'react';
import MapMobile from '@components/common/Map/MapMobile';
import { showAllAmenitiesClicked } from '@events/DLP';
import MobileBookingSection from '@components/BookingSection/MobileBookingSection';
import CaptureEmailDLPInLine from '@components/CaptureEmail/CaptureEmailDLPInLine';
import { useHotelContext } from '@context/HotelContext';
import Amenities from '@components/HotelCard/Amenities';
import PoolHours from './PoolHours';

type Props = {
  setIsAmenitiesDrawerOpen: Dispatch<SetStateAction<boolean>>;
};

export default function ProductDetailsTab({ setIsAmenitiesDrawerOpen }: Props) {
  const { hotel } = useHotelContext();

  const scrollToBookingSection = () => {
    const smartCalendarElement = document.getElementById('smart-calendar-container');
    smartCalendarElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const onShowAllAmenitiesClick = () => {
    // Event
    showAllAmenitiesClicked(hotel);

    setIsAmenitiesDrawerOpen(true);
  };

  return (
    <div>
      <MobileBookingSection
        hotelId={hotel.metadata.hotel_id}
        scrollToBookingSection={scrollToBookingSection}
      />

      <div className="border-t-8 border-b-8 border-rp-gray-divider mt-8 px-4 pt-8 pb-12">
        <p className="font-rp-gelica-light leading-26px text-22 text-rp-primary-black">Amenities</p>

        <div className="mt-4">
          {hotel.amenities && (
            <Amenities
              amenities={hotel.amenities.slice(0, 4)}
              variant="expanded"
              size="large"
              direction="vertical"
            />
          )}

          {hotel.amenities && hotel.amenities.length > 4 && (
            <div className="mt-4">
              <ButtonSecondary onClick={onShowAllAmenitiesClick}>
                Show All Amenities
              </ButtonSecondary>
            </div>
          )}
        </div>
      </div>

      {/* Pool Hours */}
      {hotel.metadata.markdown_pool_hours_details ? <PoolHours hotel={hotel} /> : null}

      {/* Map */}
      <MapMobile address={hotel.address} />

      {/* Marketing Module - Digioh Email Capture */}
      <CaptureEmailDLPInLine />
    </div>
  );
}
